import React, { useState } from "react";
import { Button, Modal, message } from "antd";


const ViewProject = ({
  showViewProject,
  setShowViewProject,
  selectedProject
}) => {
  const [open, setOpen] = useState(showViewProject);
  const [tasks, setTasks] = useState(selectedProject.tasks);


  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, '0'); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as mm/dd/yyyy
  }

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white  rounded-2xl shadow-lg w-[700px] h-[700px] overflow-y-scroll scrollbar-hidden">
          <h3 className="text-xl font-bold mb-4 text-center bg-blue-950 py-3 text-white">Project Details</h3>
          <form className="space-y-6 p-8">
            <div className="flex gap-2">
              <div className='w-full'>
                <label htmlFor="number" className="block text-sm font-medium text-gray-700">
                  Project Number
                </label>
                <input
                  type="number"
                  name="number"
                  value={selectedProject.projectNumber}
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                  disabled
                />
              </div>

              <div className=' w-full'>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Project Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={selectedProject.projectName}
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                  disabled
                />
              </div>
            </div>

            <div className='w-full'>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                Description
              </label>
              <textarea
                name="description"
                placeholder="Description"
                className="border border-gray-800 p-2 w-full"
                value={selectedProject.projectDescription}
                rows={4}
                disabled
              />
            </div>


            <div className=' w-full'>
              <label htmlFor="budget" className="block text-sm font-medium text-gray-700">
                Budget
              </label>
              <input
                type="number"
                name="budget"
                value={selectedProject.budget}
                className={`block w-full p-3 border border-gray-800 rounded-md`}
                disabled
              />
            </div>

            <div className=' w-full'>
              <label htmlFor="projectAddress" className="block text-sm font-medium text-gray-700">
                Project Address
              </label>
              <input
                type="text"
                name="projectAddress"
                value={selectedProject.projectAddress}
                className={`block w-full p-3 border border-gray-800 rounded-md`}
                disabled
              />
            </div>

            <div className="flex gap-2">
              <div className=' w-full'>
                <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                  Start Date:
                </label>
                <input
                  type="text"
                  name="startDate"
                  value={selectedProject.projectStartDate ? formatDate(selectedProject.projectStartDate) : "N/A"}
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                  disabled
                />
              </div>

              <div className=' w-full '>
                <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                  End Date:
                </label>
                <input
                  type="text"
                  name="endDate"
                  value={selectedProject.dueDate ? formatDate(selectedProject.dueDate) : "N/A"}
                  className={`block w-full p-3 border border-gray-800 rounded-md`}
                  disabled
                />
              </div>
            </div>

            {tasks.map((taskItem, index) => (
              <div className="mb-4" key={index}>
                <label className="block mb-1">Task {index + 1}:</label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    name={`task-${index}`}
                    className="border border-gray-800 p-2 w-full"
                    value={taskItem.task}
                    disabled
                  />

                  <input
                    type="text"
                    name="taskBudget"
                    placeholder="Enter the task budget"
                    className="border border-gray-800 p-2 w-full"
                    value={taskItem.taskBudget}
                    disabled
                  // onChange={(e) => handleTaskChange(index, e)}

                  />

                </div>

              </div>
            ))}

            <div className="flex justify-end gap-6 mt-16">

              <button type="submit" onClick={() => { setShowViewProject(false); setOpen(false) }} className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                Ok
              </button>

            </div>
          </form>

        </div>
      </div>






      {/* <Modal
        title="View Project Details"
        open={open}
        onCancel={() => {
          setShowViewProject(false);
          setOpen(false);
         
        }}
        footer={[
          <Button key="cancel" 
          onClick={() => {
            setShowViewProject(false)
            setOpen(false)
            }}>
            Cancel
          </Button>,
  
        ]}
        centered
        style={{
          maxHeight: "500px",
          overflowY: "scroll",
        }}
      >
        <form className="space-y-4"> */}
      {/* Name */}
      {/* <div className="mb-4">
            <label className="block mb-1">Name:</label>
            <input
              type="text"
              name="name"
              className="border p-2 w-full"
              value={selectedProject.projectName}
            />
          </div> */}

      {/* Description */}
      {/* <div className="mb-4">
            <label className="block mb-1">Description:</label>
            <textarea
              name="description"
              className="border p-2 w-full"
           
              value={selectedProject.projectDescription}
              rows={4}
            />
          </div> */}

      {/* Status */}
      {/* <div className="mb-4">
            <label className="block mb-1">Status:</label>
            <input
              type="text"
              name="status"
              className="border p-2 w-full"
         
              value={selectedProject.status}
            />
          </div> */}

      {/* Due Date */}
      {/* <div className="mb-4">
            <label className="block mb-1">Due Date:</label>
            <input
              type="date"
              name="dueDate"
              className="border p-2 w-full"
       
              value={selectedProject.dueDate}
            />
          </div> */}

      {/* Budget */}
      {/* <div className="mb-4">
            <label className="block mb-1">Budget:</label>
            <input
              type="number"
              name="budget"
              className="border p-2 w-full"
          
              value={selectedProject.budget}
            />
          </div> */}

      {/* Remaining Budget */}
      {/* <div className="mb-4">
            <label className="block mb-1">Remaining Budget:</label>
            <input
              type="number"
              name="remainingBudget"
              className="border p-2 w-full"
      
              value={selectedProject.remaining}
            />
          </div> */}

      {/* Domain Name */}
      {/* <div className="mb-4">
            <label className="block mb-1">Domain Name:</label>
            <input
              type="text"
              name="domainName"
              className="border p-2 w-full"
           
              value={selectedProject.domainName}
            />
          </div> */}

      {/* Dynamic Task Fields */}
      {/* {tasks.map((taskItem, index) => (
            <div className="mb-4" key={index}>
              <label className="block mb-1">Task {index + 1}:</label>
              <div className="flex">
                <input
                  type="text"
                  name={`task-${index}`}
                  className="border p-2 w-full"
                  value={taskItem.task}
                />
              </div>
            </div>
          ))}
        </form>
      </Modal> */}
    </>
  );
};

export default ViewProject;
